import $axios from "../../api/axios";

function getSocialApi({ callback }) {
  $axios
    .post("/api/social")
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getSocialApi
};



// WEBPACK FOOTER //
// ./src/api/social/social.js